import { render, staticRenderFns } from "./AuthCard.vue?vue&type=template&id=da8daddc&scoped=true"
import script from "./AuthCard.vue?vue&type=script&lang=js"
export * from "./AuthCard.vue?vue&type=script&lang=js"
import style0 from "./AuthCard.vue?vue&type=style&index=0&id=da8daddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8daddc",
  null
  
)

export default component.exports